import { createReducer } from '@reduxjs/toolkit'
import { IStateCustomRoles } from './TReducer'
import { Actions_CustomRoles } from './Actions'

const initialState: IStateCustomRoles = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerCustomRoles = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_CustomRoles.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_CustomRoles.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_CustomRoles.store.saveRoles, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
})

export default ReducerCustomRoles
